import { put } from 'redux-saga/effects';
import { authenticate } from 'auth/actions';
import { addCard } from 'app/routes';

export function* addCardNavigate() {
  yield put(authenticate(addCard()));
}

